import Features from './Features'

export default Features
